import { safeDecodeBase64 } from "containers/common/innovel_util";

let env;
let trackingHost;
let tokenHost;
let orderHost;
const context = '/innovel-services/scheduler-service/api';
const tokenContext = '/innovel-services/rft/api';
let loginClient;
let trackingHome;
let alertHost;
let alertContext = env === 'local' ? '/innovel-services/scheduler-service' : '';

const rawEnv = window._env_?.REACT_APP_RFT_ENV;
env = safeDecodeBase64(rawEnv, 'local') || 'local';

switch (env) {
  case 'local':
    trackingHost = 'http://localhost:8080';
    orderHost = 'http://localhost:8080';
    tokenHost = 'http://localhost:8085';
    loginClient = 'http://localhost:3005';
    trackingHome = 'http://localhost:3000';
    alertHost = 'http://10.248.118.153:8080';
    break;
  case 'prod':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
    break;
  case 'nonprod':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'qa':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'perf':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'dev':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  default:
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    alertHost = '';
}

// force API_ROOT and API_SERVER to route traffic to the local Apache/Node proxy at `/api`
export const API_ROOT = env === 'local' ? orderHost + context : '/api';
export const API_SERVER = env === 'local' ? trackingHost + '/innovel-services' : '/api';

export const TOKEN_ROOT = tokenHost + tokenContext;
export const APP_CONTEXT = '/innovel-services/scheduler-service';
export const LOGIN_ROOT = loginClient + '/innovel-services/login/login';
export const TRACKING_ROOT = trackingHome;
export const ALERT_ROOT = alertHost + alertContext;